module.exports = __webpack_public_path__ + "img/blast-chille-and-freezer.5aac1011.jpg";